import { Component, OnInit, Input } from "@angular/core";
import { currentTitle } from "../.././shared/navbar/navbar.component";
import { TranslateService } from "@ngx-translate/core";
import { Translations } from "../../localization/translations.service";

@Component({
  selector: "app-export-chart-button",
  templateUrl: "./export-chart-button.component.html",
  styleUrls: ["./export-chart-button.component.css"],
})
export class ExportChartButtonComponent implements OnInit {
  constructor(
   
    public t10s: Translations,
    public translateService: TranslateService,
    
  ){}
  @Input() chart;
  
  ngOnInit() {
    
  }

  export(params: String) {
    this.chart.exporting.export(params);
    this.chart.exporting.filePrefix =
      "TEREOS_" + currentTitle.toUpperCase().replace(" ", "_") + "_" + new Date().toISOString().slice(0, 10);
  }
}
